import { EncodingTool } from "../../../components/developerTools/EncodingTool";
import { ToolLayout } from "../../../components/developerTools/ToolLayout";



/** Displays the local URL value encoder and decoder. */
export const UrlTool = () => (
	<ToolLayout title="URL Encoder & Decoder" description="Encode and decode individual URL values using percent encoding." local>
		<EncodingTool format="url" />
	</ToolLayout>
);
